import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Plus } from 'lucide-react';
import TaskApprovalModalPage from '../Task/TaskApprovalModalPage';
import moment from 'moment';
import { fetchRejectedOrPendingTasks } from '../../redux/actions/taskActions';

const TaskApprovalPage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const dispatch = useDispatch();

const { rejectedOrPendingTasks, loading } = useSelector((state) => state.task);

  useEffect(() => {
    dispatch(fetchRejectedOrPendingTasks());
  }, [dispatch]);

  return (
    <div className="relative w-full h-screen bg-slate-700 text-white flex flex-col">
      {/* Task List */}
      <div className="flex-grow overflow-y-auto px-4 py-4 space-y-4">
        {loading && <p>Loading tasks...</p>}
        {!loading && rejectedOrPendingTasks.length === 0 && <p>No pending or rejected tasks found.</p>}
        {!loading &&
          rejectedOrPendingTasks.map((task) => (
            <div
              key={task.task_submit_id}
              className="bg-red-200 text-black rounded-xl p-4 shadow-md space-y-1"
            >
              <p><strong>Visit Location(s)</strong>: {task.task_name}</p>
              <p><strong>Visit Purpose</strong>: {task.task_title}</p>
              <p><strong>Created at</strong>: {moment(task.createTaskDate).format('ddd, MMM D, YYYY')}</p>
              <p><strong>Status</strong>: <span className="text-yellow-600">{task.status}</span></p>
            </div>
          ))}

        {/* Add New Task Button - Rectangular Style */}
        <div className="pb-4">
          <button
            className="w-full bg-white text-black rounded-xl p-4 shadow-md flex flex-col items-center space-y-2 hover:bg-gray-50 transition-colors"
            onClick={() => setIsModalOpen(true)}
          >
            <div className="border-2 border-black rounded p-1">
              <Plus className="text-black" size={24} />
            </div>
            <span className="text-lg font-medium">Add New</span>
          </button>
        </div>
          <div className="mb-24"></div>
      </div>

      {/* Modal */}
      {/* {isModalOpen && <TaskApprovalModalPage onClose={() => setIsModalOpen(false)} />} */}
      {isModalOpen && (
  <TaskApprovalModalPage
    onClose={() => setIsModalOpen(false)}
    onTaskAdded={() => dispatch(fetchRejectedOrPendingTasks())}
  />
)}

    </div>
  );
};

export default TaskApprovalPage;